export default {
    filterBar: {
        sideFilterAria: 'Filter strane',
        countryFilterAria: 'Filter države',
        allCountriesAria: 'Prikaži ugovore iz svih država',
        hrOnlyAria: 'Prikaži samo HR ugovore',
        siOnlyAria: 'Prikaži samo SI ugovore',
    },
}
